import { useT } from "../i18n";
import type { BookResult } from "../api";
import { loadTimezone } from "../lib/timezones";

export function Confirm({ result, onNew }: { result: BookResult; onNew: () => void }) {
  const { t } = useT();
  const timezone = loadTimezone();
  const when = new Intl.DateTimeFormat("en-US", {
    dateStyle: "full",
    timeStyle: "short",
    timeZone: timezone,
  }).format(new Date(result.when));

  const waText = encodeURIComponent(
    `Hello Lucas! I have confirmed my technical architecture session at Automatrix for ${when}. Looking forward to discussing our systems.`
  );

  return (
    <div className="panel center confirm-panel">
      <div className="check">✓</div>
      <h2>{t("bookedTitle")}</h2>
      <p className="lead" style={{ marginBottom: 20 }}>
        Your architecture session has been successfully booked. Confirmation and calendar invitations have been dispatched.
      </p>

      <div className="confirm-line">
        <strong>{t("bookedWhen")}</strong>
        <span>{when}</span>
      </div>

      {result.meetUrl && (
        <div className="confirm-line">
          <strong>{t("meetLink")}</strong>
          <a href={result.meetUrl} target="_blank" rel="noreferrer" className="meet-badge-link">
            {result.meetUrl.includes("meet.google.com") ? "Google Meet ↗" : "Join Video Room ↗"}
          </a>
        </div>
      )}

      {result.emailSent && (
        <p className="muted" style={{ marginTop: 12 }}>
          {t("bookedEmailSent")}
        </p>
      )}

      <div className="confirm-actions-row" style={{ marginTop: 24, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
        <a
          href={`https://wa.me/5521988407505?text=${waText}`}
          target="_blank"
          rel="noopener noreferrer"
          className="btn primary"
          style={{ textDecoration: "none" }}
        >
          Confirm via WhatsApp (+55 21 98840-7505) ↗
        </a>
        <a
          href="/portfolio#repos"
          className="btn ghost"
          style={{ textDecoration: "none" }}
        >
          Explore 168 Repositories ↗
        </a>
        <button className="btn ghost" onClick={onNew} type="button">
          {t("newBooking")}
        </button>
      </div>
    </div>
  );
}
